import { Link } from "react-router-dom";

export default function Info() {
  return (
    <div className="pt-6">
      <h1 className="text-3xl font-extrabold tracking-tight fade-up">Info.</h1>

      <div className="mt-6 space-y-4">
        <section className="rounded-3xl border border-[color:var(--hairline)] bg-white p-5 fade-up" data-testid="info-disclaimer">
          <h2 className="text-sm font-extrabold tracking-[0.14em] uppercase">Nota importante</h2>
          <p className="mt-3 text-sm leading-7 text-[color:var(--text-2)]">
            Questa app è uno strumento di <strong className="text-[color:var(--ink)]">supporto alla preparazione</strong> del test di idoneità del corso propedeutico per allenatori.
            Non è un prodotto ufficiale FIGC, non è affiliata alla FIGC e non sostituisce i materiali ufficiali del Settore Tecnico.
            Regole, programmi e contenuti dei corsi possono cambiare: fai sempre riferimento ai canali ufficiali della Federazione e del tuo Comitato Regionale.
          </p>
        </section>

        <section className="rounded-3xl border border-[color:var(--hairline)] bg-white p-5 fade-up">
          <h2 className="text-sm font-extrabold tracking-[0.14em] uppercase">Contenuti</h2>
          <p className="mt-3 text-sm leading-7 text-[color:var(--text-2)]">
            Le <strong className="text-[color:var(--ink)]">schede di studio</strong> dei 10 moduli e le <strong className="text-[color:var(--ink)]">simulazioni ufficiali</strong> sono contenuti originali della piattaforma.
            Eventuali materiali contrassegnati “CONTENUTO DI ESEMPIO” sono dimostrativi e in corso di sostituzione: tutto è guidato dai dati, senza modifiche all'app.
          </p>
        </section>

        <section className="rounded-3xl border border-[color:var(--hairline)] bg-white p-5 fade-up">
          <h2 className="text-sm font-extrabold tracking-[0.14em] uppercase">Come funziona il test</h2>
          <ul className="mt-3 space-y-2 text-sm leading-6 text-[color:var(--text-2)]">
            <li><span className="font-mono font-semibold text-[color:var(--ink)]">60</span> domande a risposta multipla (4 opzioni, 1 corretta), nessuna penalità.</li>
            <li><span className="font-mono font-semibold text-[color:var(--ink)]">4×15</span> quattro blocchi da 15 domande, timer unico da 60 minuti.</li>
            <li><span className="font-mono font-semibold text-[color:var(--ink)]">9/15</span> in ciascun blocco per l'idoneità: un solo blocco sotto soglia = non idoneo.</li>
          </ul>
        </section>

        <section className="rounded-3xl border border-[color:var(--hairline)] bg-white p-5 fade-up" data-testid="info-privacy">
          <h2 className="text-sm font-extrabold tracking-[0.14em] uppercase">Privacy</h2>
          <p className="mt-3 text-sm leading-7 text-[color:var(--text-2)]">
            Trattiamo solo i dati necessari al funzionamento dell'app: <strong className="text-[color:var(--ink)]">email, nome, progressi di studio e risultati dei quiz</strong>.
            I dati non vengono condivisi con terze parti né usati per finalità di marketing. Il consenso viene raccolto in fase di registrazione.
          </p>
          <p className="mt-3 text-sm leading-7 text-[color:var(--text-2)]">
            In ogni momento puoi chiedere l'<strong className="text-[color:var(--ink)]">anonimizzazione o la cancellazione definitiva</strong> del tuo account e di tutti i dati collegati,
            contattando l'amministratore del corso. La cancellazione rimuove progressi, tentativi e dati personali in modo irreversibile.
          </p>
        </section>

        <section className="rounded-3xl border border-[color:var(--hairline)] bg-white p-5 fade-up">
          <h2 className="text-sm font-extrabold tracking-[0.14em] uppercase">Marchi</h2>
          <p className="mt-3 text-sm leading-7 text-[color:var(--text-2)]">
            FIGC, UEFA e ogni altro marchio citato appartengono ai rispettivi proprietari. L'app non utilizza loghi o marchi registrati ed è indipendente da tali organizzazioni.
          </p>
        </section>
      </div>

      <Link to="/" className="mt-8 inline-block rounded-full border border-[color:var(--hairline)] bg-white px-6 py-3 font-semibold text-sm hover:bg-[color:var(--bg-subtle)] transition-colors duration-200" data-testid="info-back-home-button">
        Torna alla home
      </Link>
    </div>
  );
}
